module.exports = __webpack_public_path__ + "img/euro-track-simulator-2.3e033427.png";